import * as Yup from "yup";

export const editProfile = {
  title: "Edit Profile",
  fields: [
    { type: "photo", name: "profileImage" },
    {
      label: "Role",
      type: "staticSelect",
      name: "role",
      active: true,
      value: "",
      data: [
        { name: "SADMIN", value: "SADMIN" },
        { name: "Admin", value: "ADMIN" },
        { name: "Campaign Manager", value: "CAMPAIGNMANAGER" },
        { name: "Customer", value: "CUSTOMER" }
      ]
    },
    {
      label: "Email",
      type: "input",
      active: true,
      placeholder: "e.g. smith.doe@gmail.com",
      name: "email",
      value: ""
    },
    {
      label: "First Name",
      type: "input",
      placeholder: "e.g. John",
      isRequired: true,
      name: "firstName",
      value: "",
      disabled: true
    },
    {
      label: "Last Name",
      type: "input",
      placeholder: "e.g. Smith",
      name: "lastName",
      value: "",
      disabled: true
    },
    {
      label: "Phone Number",
      placeholder: "e.g. 9854795626",
      type: "input",
      name: "contactnumber",
      value: "",
      disabled: true
    }

  ]
};
export const addPasswordForm = {
  title: "Change Password",
  fields: [
    {
      label: "Old Password",
      placeholder: "Enter Old Password",
      type: "password",
      name: "oldPassword",
      isRequired: true,
      value: ""
    },
    {
      label: "New Password",
      type: "password",
      placeholder: "Enter New Password",
      isRequired: true,
      name: "newPassword",
      value: ""
    },
    {
      label: "Confirm Password",
      type: "password",
      placeholder: "Confirm New Password",
      name: "confirmPassword",
      isRequired: true,
      value: ""
    }
  ]
};

export const getName = id => `query{
allUsersdata(where:{id:${id}}){
Usersdata{
id
firstName
profileImage
lastName
role
email
contactnumber
 customerIbfk5rel{
    Customers{
      company
    }
  }
}
}
}`;
export const editUsersValidation = Yup.object().shape({

  contactnumber: Yup.string()
    .matches(/^\+?[0-9]*$/, {
      message: "Please enter valid phone no.",
      excludeEmptyString: true
    })
    .max(16, "Phone number should be less than 16 digits"),
  firstName: Yup.string()
    .required("Please enter name")
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "First name should be less than 30 characters"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", data => {
      if (data !== undefined && data.trim().length === 0 && data !== "")
        return false;
      else return true;
    })
    .max(30, "Last name should be less than 30 characters")
});

export const changePasswordValidation = Yup.object().shape({
  oldPassword: Yup.string()
    .required("Please enter current password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Please enter valid current password",
      excludeEmptyString: true
    }),
  newPassword: Yup.string()
    .required("Please enter password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Password can't contain spaces",
      excludeEmptyString: true
    })
    .min(8, "Password should be minimum 8 characters")
    .max(60, "Password should be maximum 60 characters"),
  confirmPassword: Yup.string()
    .required("Please re-enter password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Please enter valid confirm password",
      excludeEmptyString: true
    })
    .test("passwords-match", "Passwords do not match! please check.", function(
      value
    ) {
      return this.parent.newPassword === value;
    })
    .min(8, "Confirm password should be minimum 8 characters")
});
